var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"qunfeng-banner",attrs:{"id":_vm.containerId}})
}
var staticRenderFns = []

export { render, staticRenderFns }